export const callVideoActions = {
  methods: {
    commitToggleDevice(kind, status) {
      this.$store.commit('TOGGLE_DEVICE', { kind, status })
    }
  }
}
